import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "accordion__item-header" }
const _hoisted_3 = { class: "accordion__item-content" }

import { ref } from 'vue';

import AccordionToggleIcon from './AccordionToggleIcon.vue';

export type AccordionItem = {
  title: string;
  content?: any;
  component: object;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'Accordion',
  props: {
    items: null,
    singleExpand: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  items: AccordionItem[];
  singleExpand?: boolean;
}



const accordionEl = ref<HTMLElement | null>(null);
const contentRefs = ref<HTMLElement[]>([]);
const accordionIndexes = ref<Map<number, string>>(new Map());

function toggleExpand(index: number) {
  const isCurrentlyExpanded = accordionIndexes.value.has(index);
  const clonedMap = new Map(accordionIndexes.value);

  if (props.singleExpand) {
    clonedMap.clear();

    if (!isCurrentlyExpanded) {
      clonedMap.set(index, computeHeight(index));
    }
  } else if (isCurrentlyExpanded) {
    clonedMap.delete(index);
  } else {
    clonedMap.set(index, computeHeight(index));
  }

  requestAnimationFrame(() => (accordionIndexes.value = clonedMap));
}

function computeHeight(index: number) {
  const itemRef = contentRefs.value[index];
  itemRef.style.height = 'auto';
  const height = getComputedStyle(itemRef).height;
  itemRef.style.height = '0px';
  return height;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "accordion",
    ref_key: "accordionEl",
    ref: accordionEl
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "accordion__item",
        key: index
      }, [
        _createElementVNode("button", {
          class: "clean-button accordion__item-header-wrapper",
          onClick: ($event: any) => (toggleExpand(index))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", null, _toDisplayString(item.title), 1),
            _createVNode(AccordionToggleIcon, {
              isExpanded: accordionIndexes.value.has(index)
            }, null, 8, ["isExpanded"])
          ])
        ], 8, _hoisted_1),
        _createElementVNode("div", {
          class: "accordion__item-body",
          ref_for: true,
          ref_key: "contentRefs",
          ref: contentRefs,
          style: _normalizeStyle([
          accordionIndexes.value.has(index)
            ? { height: accordionIndexes.value.get(index) }
            : { height: '0px'},
        ])
        }, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(item.component), {
              content: item.content
            }, null, 8, ["content"]))
          ])
        ], 4)
      ]))
    }), 128))
  ], 512))
}
}

})